import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-line text-background-50 text-xl"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">PG官网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              PG官网是官方正版游戏平台，致力于为玩家提供安全、可靠的游戏体验。丰富的游戏种类、稳定的服务器和优质的客服支持，让您的游戏之旅更加精彩。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="#footer-games" className="text-background-50">游戏分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { href: '/category/dongzuo', label: '动作游戏' },
                { href: '/category/jiaose-banyan', label: '角色扮演' },
                { href: '/category/celve', label: '策略游戏' },
                { href: '/category/xiuxian', label: '休闲游戏' },
                { href: '/category/tiyu', label: '体育竞技' },
                { href: '/category/qipai', label: '棋牌游戏' },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="#footer-guide" className="text-background-50">快速指南</a>
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { href: '/article/pg-guanwang-xinshou-zhinan', label: '新手入门指南' },
                { href: '/article/pg-youxi-anquanxing-baozhang', label: '安全防护指南' },
                { href: '/article/pg-guanwang-chongzhi-jiaocheng', label: '充值教程' },
                { href: '/article/pg-shouyou-xiazai-anzhuang', label: '手游下载安装' },
                { href: '/about', label: '关于我们' },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="#footer-contact" className="text-background-50">联系我们</a>
            </h4>
            <div className="flex flex-col gap-3 text-sm text-background-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>support@pg-official.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-XXXX</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>7×24小时在线客服</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-500">
          <p>&copy; {currentYear} PG官网 版权所有 | 保留一切权利</p>
          <div className="flex items-center gap-4">
            <a href="#footer-privacy" className="hover:text-primary-400 transition-colors duration-200" rel="nofollow">隐私政策</a>
            <a href="#footer-terms" className="hover:text-primary-400 transition-colors duration-200" rel="nofollow">服务条款</a>
            <a href="#footer-sitemap" className="hover:text-primary-400 transition-colors duration-200" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}